/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from "react";
import { BiLockAlt, BiLogOut } from "react-icons/bi";
import browserStorage from "store";
import {
  Avatar,
  // AvatarFallback,
  // AvatarImage,
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@repo/ui";
import { Link } from "react-router-dom";
import { UserContext } from "utils/reducers/user";
import Logo from "assets/images/logo.png";
// import ProfilePic from "assets/images/logo1.png";
import { NAV_MENU } from "utils/constant";
import { isOperationAllowed } from "utils/helper";
import { MdPerson } from "react-icons/md";

export default function Layout({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) {
  return (
    <>
      <Header />
      {children}
    </>
  );
}

function Header() {
  const { DisplayName } = useContext(UserContext) as { DisplayName: string };

  const handleLogout = () => {
    if (process.env.REACT_APP_CLIENT !== "CT") {
      browserStorage.clearAll();
      sessionStorage.clear();
    }
    window.top?.postMessage(
      { type: "logout" },
      process.env.REACT_APP_ADMIN as string
    );
  };

  return (
    <header className="flex bg-white items-center gap-4 px-4 py-6 shadow-md">
      <Link to="/dashboard">
        <img className="max-w-[110px]" src={Logo} alt="logo" />
      </Link>
      <div className="border border-gray-500 h-6 " />
      <NavigationMenu>
        <NavigationMenuList>
          {NAV_MENU.map((item) =>
            isOperationAllowed(item.permission) ? (
              <>
                {item.subMenu?.length ? (
                  <NavigationMenuItem key={item.path}>
                    <NavigationMenuTrigger>
                      {item.path ? (
                        <Link
                          to={item.path}
                          className="flex gap-2 items-center"
                        >
                          <item.icon style={item.iconStyle} />
                          {item.label}
                        </Link>
                      ) : (
                        <div className="flex gap-2 items-center">
                          <item.icon />
                          {item.label}
                        </div>
                      )}
                    </NavigationMenuTrigger>
                    <NavigationMenuContent dir="ventricle">
                      <ul className="p-2">
                        {item.subMenu.map((subItem) =>
                          isOperationAllowed(
                            item.permission,
                            subItem.permission
                          ) ? (
                            <li key={subItem.path}>
                              <Link
                                className="w-full block text-sm hover:bg-secondary/20 p-2 rounded-md text-nowrap"
                                to={subItem.path || "/"}
                              >
                                {subItem.label}
                              </Link>
                            </li>
                          ) : null
                        )}
                      </ul>
                    </NavigationMenuContent>
                  </NavigationMenuItem>
                ) : (
                  <NavigationMenuItem key={item.path}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                    >
                      <Link
                        to={item.path || "/"}
                        className="flex gap-2 items-center"
                      >
                        <item.icon />
                        {item.label}
                      </Link>
                    </NavigationMenuLink>
                  </NavigationMenuItem>
                )}
              </>
            ) : null
          )}
        </NavigationMenuList>
      </NavigationMenu>
      <div className="flex items-center gap-2 ml-auto">
        <span className="uppercase">{DisplayName}</span>
        <Menubar className="border-none">
          <MenubarMenu>
            <MenubarTrigger className="p-0 cursor-pointer">
              <Avatar className="border w-12 h-12 flex items-center justify-center bg-secondary">
                {/* <AvatarImage className="object-contain" src={ProfilePic} /> */}
                <MdPerson size="24px" className="text-white" />
                {/* <AvatarFallback>{DisplayName.at(0)}</AvatarFallback> */}
              </Avatar>
            </MenubarTrigger>
            <MenubarContent align="end">
              <MenubarItem className="gap-3 cursor-pointer" asChild>
                <Link to="/change-password">
                  <BiLockAlt />
                  Change Password
                </Link>
              </MenubarItem>
              <MenubarItem
                className="gap-3 cursor-pointer"
                onClick={handleLogout}
              >
                <BiLogOut />
                Logout
              </MenubarItem>
            </MenubarContent>
          </MenubarMenu>
        </Menubar>
      </div>
    </header>
  );
}
